<template>
  <transition name="fade">
    <div class="landing" :style="{zIndex: showLandingTop ? 1 : 0}" :class="{'short': short}">
      <div class="bg landing_bg" ref="landing">
        <div class="landing_papper landing_poster">
          <img src="../assets/imgs/landing_poster_papper.png" alt />
          <div class="landing_name">
            <span>@{{userInfo.name}}</span>
            <div class="touxue">同学</div>
            <span class="line"></span>
          </div>
          <div class="landing_word">
            <div v-html="decode(paper.content)"></div>
            <img
              class="edit_img"
              :class="'edit_img_'+userInfo.year"
              :src="decode(paper.img_url)"
              alt
              v-show="paper.img_url!==''"
            />
          </div>
          <div class="weight year" :class="isAndroid?'android-year':''">{{userInfo.year}}</div>
          <div class="landing_info">
            <span
              class="weight province"
              :class="isAndroid?'android-province':''"
            >{{userInfo.province}}</span>
            <img src="../assets/imgs/landing_icon_join.png" alt />
          </div>
          <div class="landing_num">
            <span>{{number}}</span>
          </div>
        </div>
      </div>
      <div class="edit center">
        <div class="bg"></div>
        <img class="edit_bg" src="../../public/imgs/edit_bg_2.png" />
        <img class="ticket" src="../assets/imgs/edit_ticket.png" />

        <div class="edit_paper">
          <div class="edit_paper_title">{{userInfo.year}}年{{userInfo.province}}卷</div>

          <div class="edit_content_container" ref="editContainer">
            <div>
              <div class="edit_content" ref="editContent" v-html="decode(paper.content)"></div>
              <img
                class="edit_img"
                :class="'edit_img_'+userInfo.year"
                :src="decode(paper.img_url)"
                alt
              />
            </div>
          </div>

          <div class="edit_name">{{userInfo.name}}</div>
          <div class="edit_province">{{userInfo.province}}</div>

          <img class="edit_pen_hat" src="../assets/imgs/edit_pen_hat.png" />
          <img class="edit_pen" src="../assets/imgs/edit_pen.png" />

          <div class="edit_back">
            <img src="../assets/imgs/landing_save.png" />
          </div>
        </div>

        <div class="capture center">
          <img :src="imgSrc" :style="{'pointer-events': saveDone ? 'auto' : 'none'}" />
        </div>

        <div class="edit_submit center" @click="join">
          <img src="../assets/imgs/landing_btn_join.png" />
        </div>

        <img
          class="logo middle-center"
          :src="logoUrl"
          :style="{'mix-blend-mode':isNewsArticle?'normal':'multiply'}"
        />
        <div class="landing_back" @click="back">
          <img src="../assets/imgs/landing_btn_again.png" alt />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Landing",
  props: {
    number: {
      type: String,
      default: "1000"
    },
    userArticle: {
      type: Object,
      default() {
        return { article: "江苏", title: "" };
      }
    },
    userInfo: {
      type: Object,
      default() {
        return {
          name: "zly",
          year: 2019,
          province: "河北"
        };
      }
    },
    showLanding: {
      type: Boolean,
      default: false
    },
    short: {
      type: Boolean,
      default: false
    },
    paper: Object,
    showLandingTop: Boolean,
    platform: {
      type: String,
      default: "weixin"
    }
  },
  data() {
    return {
      imgSrc: "",
      fontSize: "",
      saveDone: false,
      logoUrl: require("../assets/imgs/logo.png"),
      isNewsArticle: false,
      isAndroid: false
    };
  },
  computed: {
    newArticle() {
      // if (this.$refs.landing_word.clientHeight) {
      //   return Math.floor(this.$refs.landing_word.clientHeight / 48);
      // }
    }
  },
  methods: {
    decode(data) {
      if (data) return data.replace(/\n/g, "<br />");

      return "";
    },

    back() {
      this.$emit("back");

      this.imgSrc = null;

      this.saveDone = false;
    },
    GetUri(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURI(r[2]);
      return null;
    },
    join() {
      this.$emit("join");
    },
    screenCapture() {
      // let height = Math.min(window.innerHeight, 1205);
      // let y = window.innerHeight - height;
      html2canvas(this.$refs.landing, {
        width: 750,
        height: 1205,
        y: (window.innerHeight - 1205) / 2 + (this.short ? -20 : 30),
        x: 0,
        scale: 1,
        useCORS: true,
        ignoreElements(e) {
          return /ignore/.test(e.className);
        }
      }).then(canvas => {
        let _this = this;
        canvas.style.position = "absolute";
        canvas.style.zIndex = 99;
        canvas.style.left = 0;
        canvas.style.top = 0;
        let ctx = canvas.getContext("2d");
        let img = new Image();
        let logo = new Image();

        let UserAgent = navigator.userAgent.toLowerCase();
        let inside = /newsarticle/.test(UserAgent);
        if (
          /newsarticle/.test(UserAgent) ||
          /micromessenger/.test(UserAgent) ||
          /weibo/.test(UserAgent)
        ) {
          if (/newsarticle/.test(UserAgent)) {
            img.src = require("../assets/imgs/landing_code_tt.png");
            MtaH5.clickStat("tt_save");
            // this.logoUrl = require("../assets/imgs/search_box.png");
          } else if (/micromessenger/.test(UserAgent)) {
            img.src = require("../assets/imgs/landing_code_wx.png");
            MtaH5.clickStat("wx_save");
          } else if (/weibo/.test(UserAgent)) {
            img.src = require("../assets/imgs/landing_code_wb.png");
            MtaH5.clickStat("wb_save");
          }
        } else {
          let from = this.GetUri("from");
          if (from == "tt" || from == "wx" || from == "wb") {
            img.src = require("../assets/imgs/landing_code_" + from + ".png");
            MtaH5.clickStat(from + "_save");
          } else {
            img.src = require("../assets/imgs/landing_code_tt.png");
            inside = true;
            MtaH5.clickStat("tt_save");
            // this.logoUrl = require("../assets/imgs/search_box.png");
          }
        }

        // console.log(img)

        img.onload = () => {
          // console.log(canvas.clientWidth, canvas.clientHeight);
          console.log(img.width);
          ctx.drawImage(img, (750 - img.width) / 2, 919);
          if (inside) {
            logo.src = require("../assets/imgs/landing_logo.png");
            logo.onload = () => {
              ctx.drawImage(logo, 36, 30);
              _this.imgSrc = canvas.toDataURL("image/jpeg", 0.9);
              _this.saveDone = true;
              _this.$emit("loaded");
            };
          } else {
            _this.imgSrc = canvas.toDataURL("image/jpeg", 0.9);
            _this.saveDone = true;
            _this.$emit("loaded");
          }
        };
      });
    },
    getImg() {
      this.$nextTick(() => {
        this.fontSize =
          55 - Math.max(this.userArticle.title.length, 0) * 1.5 + "px";
        setTimeout(() => {
          this.screenCapture();
        }, 500);
      });
    }
  },
  mounted() {
    // alert(window.innerHeight);
    this.$nextTick(() => {
      // console.log(this.userInfo);
      // this.screenCapture();
      // console.log(Math.floor(this.$refs.landing_word.clientHeight / 48));
      // let line = Math.floor(this.$refs.landing_word.clientHeight / 48);
      // if (line == 1 || line == 3) {
      //   this.userArticle.article += "\n&nbsp";
      // }
      let UserAgent = navigator.userAgent.toLowerCase();
      if (/newsarticle/.test(UserAgent)) {
        this.isNewsArticle = true;
        this.logoUrl = require("../assets/imgs/search_box.png");
      } else {
        this.logoUrl = require("../assets/imgs/logo.png");
      }
      if (/android/.test(UserAgent)) {
        this.isAndroid = true;
      }
    });
  },
  watch: {
    // showLanding(e) {
    //   this.$nextTick(() => {
    //     if (e) {
    //       console.log(e);
    //       this.fontSize = 55-Math.max(this.userArticle.title.length,0)*1.5+'px'
    //       setTimeout(() => {
    //         this.screenCapture();
    //       }, 500);
    //       // let line = Math.floor(this.$refs.landing_word.clientHeight / 48);
    //       // console.log(line);
    //       // if (line == 1 || line == 3) {
    //       //   this.userArticle.article += "\n&nbsp";
    //       // }
    //     }
    //   });
    // }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.edit {
  width: 750px;
  height: 1624px;
  .edit_bg {
    position: absolute;
    left: 23px;
    top: 255px;
    opacity: 0;
    animation: fadeIn 1s forwards;
    animation-delay: 1s;
  }
  .ticket {
    position: absolute;
    left: 0;
    top: 297px;
  }
  .edit_paper {
    width: 651px;
    height: 1081px;
    background: url(../../public/imgs/edit_bg.png);
    position: absolute;
    left: 57px;
    top: 294px;
    text-align: left;
    color: #4c4b4b;
    .edit_paper_title {
      color: #7a7777;
      font-size: 35px;
      font-weight: bold;
      text-align: center;
      margin-top: 77px;
      font-family: "黑体";
    }
    .edit_content_container {
      width: 436px;
      position: absolute;
      // text-align: justify;
      left: 100px;
      top: 205px;
      font-size: 22px;
      line-height: 29px;
      color: #818080;
      img {
        display: block;
        max-width: 100%;
      }
    }
    .edit_img {
      margin: 0 auto;
      margin-top: 30px;
      &.edit_img_2000 {
        margin-top: 10px;
      }
      &.edit_img_2016 {
        margin-top: 3px;
      }
      &.edit_img_2019 {
        margin-top: 13px;
      }
    }

    .edit_name,
    .edit_province {
      position: absolute;
      top: 210px;
      transform: rotate(-90deg);
      left: -3px;
      width: 81px;
      text-align: center;
    }
    .edit_name {
      top: 380px;
    }
    .edit_pen_hat {
      position: absolute;
      top: 522px;
      left: -58px;
    }
    .edit_pen {
      position: absolute;
      right: -42px;
      bottom: 192px;
      transform-origin: 100% 100%;
    }
    .edit_edit {
      position: absolute;
      right: 30px;
      bottom: 213px;
    }
    .edit_back {
      position: absolute;
      bottom: 26px;
      left: -14px;
    }
  }
  .edit_submit {
    position: absolute;
    margin-top: 470px;
    margin-left: 198px;
  }
}
.landing {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  &.short {
    margin-top: -60px;
  }
  .bg {
    // margin-top: -120px;
    position: relative;
  }
  .landing_bg {
    z-index: -1;
    position: absolute;
    margin-top: 0;
  }
  .landing_back {
    position: absolute;
    left: 15px;
    top: 290px;
  }
  .landing_papper_bg {
    position: absolute;
    right: 0px;
    top: 252px;
  }
  .landing_papper_bottom {
    position: absolute;
    right: 47px;
    top: 1204px;
  }
  .landing_papper {
    position: absolute;
    left: 0;
    top: 289px;
    position: absolute;
    left: 0;
    pointer-events: none;
    .landing_word {
      color: #818080;
      width: 436px;
      position: absolute;
      text-align: justify;
      left: 160px;
      top: 389px;
      font-size: 18px;
      line-height: 29px;
      .edit_img_2016 {
        // margin: 0 auto;
        margin-left: 95px;
        transform: scale(0.8);
      }
      .edit_img_1983 {
        margin-left: 102px;
        margin-top: 40px;
      }
      .edit_img_1991 {
        margin-left: 63px;
        margin-top: 40px;
      }
      .edit_img_1996 {
        // margin: 0 auto;
        margin-left: -67px;
        transform: scale(0.8);
        margin-top: -12px;
      }
      .edit_img_2000 {
        margin-left: -17px;
        margin-top: 14px;
      }
      .edit_img_2019 {
        // margin: 0 auto;
        margin-left: -57px;
        transform: scale(0.65);
        margin-top: -50px;
      }
      .edit_img_2005 {
        margin-left: 32px;
        margin-top: 40px;
      }
      .edit_img_2007 {
        margin-left: 125px;
        margin-top: 40px;
      }
      .edit_img_2010 {
        margin-left: 38px;
        margin-top: 30px;
      }
      .edit_img_2012 {
        margin-left: 122px;
        margin-top: 30px;
      }
    }
    .year {
      margin-left: -30px;
      position: absolute;
      top: 144px;
      text-align: center;
      font-size: 74px;
      color: #ca8773;
      width: 100%;
      line-height: 1em;
      letter-spacing: -0.06em;
    }
    .android-year {
      margin-left: -30px;
      top: 132px;
    }
    .weight {
      font-family: SourceHanSerifBold;
    }
    .landing_info {
      position: absolute;
      top: 214px;
      text-align: center;
      color: #7a7777;
      font-size: 75px;
      color: #ca8773;
      width: 100%;
      .province {
        font-size: 60px;
        // margin-left: 30px;
        // line-height: 1em;
      }
      .android-province {
        // margin-top: -10px;
        position: relative;
        top: -10px;
      }
      img {
        margin-bottom: -7px;
        margin-left: 4px;
      }
    }
    .landing_num {
      position: absolute;
      right: 124px;
      top: 60px;
      font-size: 23px;
      color: #817e7e;
      width: 80px;
      text-align: center;
    }
    .landing_name {
      position: absolute;
      top: 54px;
      left: 138px;
      font-size: 23px;
      color: #7a7777;
      .line {
        width: 114%;
        height: 1px;
        background-color: #7a7777;
        display: block;
        position: absolute;
        bottom: -10px;
        left: 50%;
        transform: translateX(-50%);
      }
      .touxue {
        position: absolute;
        right: -65px;
        top: 4px;
        font-size: 22px;
      }
    }
  }
  .landing_poster {
    top: 328px;
    // .landing_num {
    //   top: 76px;
    // }
    // .landing_info {
    //   top: 221px;
    // }
    // .landing_word {
    //   top: 577px;
    // }
    // .landing_name {
    //   top: 68px;
    // }
  }
  .landing_file {
    top: 1133px;
  }

  .landing_save {
    left: 82px;
    position: absolute;
    top: 956px;
  }
  .landing_btn_join {
    position: absolute;
    left: 405px;
    top: 1243px;
  }
  // .landing_save {
  //   left: 82px;
  //   position: absolute;
  // }
  // .landing_btn_join {
  //   position: absolute;
  //   left: 405px;
  // }
  // position: absolute;
  //   top: 1182px;
  //   width: 582px;
  //   display: flex;
  //   justify-content: space-between;
  .landing_tip {
    position: absolute;
    left: 80px;
    top: 1250px;
  }
  .capture {
    height: 100%;
    width: 100%;
    opacity: 0;
    img {
      width: 100%;
      height: 100%;
      pointer-events: auto;
    }
  }
}

.landing.short {
  // margin-top: -120px;
  // .landing_papper_bottom {
  //   top: 1240px;
  // }
  // .landing_save {
  //   top: 893px;
  // }
  // .landing_tip {
  //   top: 1281px;
  // }
  .landing_back {
    top: 334px;
  }
  // .landing_papper {
  //   top: 349px;
  // }
  // .landing_buttons {
  //   top: 1247px;
  // }
}
.landing_bg.short {
  margin-top: -30px;
}
</style>
